import { render, staticRenderFns } from "./AfCode.vue?vue&type=template&id=14a05d30"
import script from "./AfCode.vue?vue&type=script&lang=js"
export * from "./AfCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports